class LolaRunwayHero extends HTMLElement {
  constructor() {
    super();
    this.player = this.querySelector('[data-runway-player]');
    if (!this.player) return;

    this.trigger = this.querySelector('[data-runway-player-trigger]');
    this.videoWrap = this.querySelector('[data-runway-player-video]');
    this.progressBar = this.querySelector('[data-runway-player-progress-bar]');
    this.video = this.videoWrap ? this.videoWrap.querySelector('video') : null;
    this.frames = this.videoWrap ? Array.from(this.videoWrap.querySelectorAll('iframe')) : [];

    this.state = 'idle';
    this.tickHandle = null;

    this.handleTrigger = this.handleTrigger.bind(this);
    this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleEnded = this.handleEnded.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (this.trigger) this.trigger.addEventListener('click', this.handleTrigger);
    if (this.video) {
      this.video.addEventListener('timeupdate', this.handleTimeUpdate);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);
      this.video.addEventListener('ended', this.handleEnded);
    }
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    if (this.trigger) this.trigger.removeEventListener('click', this.handleTrigger);
    if (this.video) {
      this.video.removeEventListener('timeupdate', this.handleTimeUpdate);
      this.video.removeEventListener('play', this.handlePlay);
      this.video.removeEventListener('pause', this.handlePause);
      this.video.removeEventListener('ended', this.handleEnded);
    }
    window.removeEventListener('resize', this.handleResize);
    if (this.tickHandle) {
      cancelAnimationFrame(this.tickHandle);
      this.tickHandle = null;
    }
  }

  handleTrigger() {
    if (this.state === 'playing') {
      this.pause();
    } else {
      this.play();
    }
  }

  play() {
    if (!this.videoWrap) return;

    this.videoWrap.hidden = false;
    this.player.dataset.state = 'playing';

    if (this.video) {
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch(() => {
          this.player.dataset.state = 'idle';
        });
      }
    } else if (this.frames.length) {
      this.frames.forEach(frame => {
        const frameSrc = frame.getAttribute('src') || '';
        if (frameSrc && !frameSrc.includes('autoplay=')) {
          const separator = frameSrc.includes('?') ? '&' : '?';
          frame.setAttribute('src', `${frameSrc}${separator}autoplay=1&mute=1`);
        }
      });
    }

    this.state = 'playing';
    if (this.trigger) this.trigger.setAttribute('aria-label', 'Pausar vídeo');
  }

  pause() {
    if (this.video) this.video.pause();
    if (this.frames.length && this.videoWrap) this.videoWrap.hidden = true;
    this.player.dataset.state = 'paused';
    this.state = 'paused';
    if (this.trigger) this.trigger.setAttribute('aria-label', 'Reproducir vídeo');
  }

  handleTimeUpdate() {
    if (!this.video || !this.progressBar) return;
    const duration = this.video.duration;
    if (!duration || Number.isNaN(duration)) return;
    const ratio = Math.min(this.video.currentTime / duration, 1);
    this.progressBar.style.width = `${ratio * 100}%`;
  }

  handlePlay() {
    this.player.dataset.state = 'playing';
    this.state = 'playing';
  }

  handlePause() {
    this.player.dataset.state = 'paused';
    this.state = 'paused';
  }

  handleEnded() {
    this.player.dataset.state = 'ended';
    this.state = 'ended';
    if (this.progressBar) this.progressBar.style.width = '100%';
  }

  handleResize() {
    if (this.tickHandle) return;
    this.tickHandle = requestAnimationFrame(() => {
      this.tickHandle = null;
    });
  }
}

if (!customElements.get('lola-runway-hero')) {
  customElements.define('lola-runway-hero', LolaRunwayHero);
}
